var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowerProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0969 12.441C13.5146 12.441 16.2852 9.67039 16.2852 6.25271C16.2852 2.83503 13.5146 0.0644531 10.0969 0.0644531C6.67927 0.0644531 3.9087 2.83503 3.9087 6.25271C3.9087 9.67039 6.67927 12.441 10.0969 12.441Z",
    fill: "#B08C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7072 20.2685C18.0474 16.4572 14.2976 13.9778 10.1174 13.9778C5.93729 13.9778 2.16698 16.4367 0.527708 20.2685C0.302309 20.7808 0.527708 21.3545 1.03998 21.5799C1.10145 21.6209 1.18342 21.6414 1.24489 21.6414V21.6619H18.7851C18.9285 21.6619 19.0719 21.6414 19.1949 21.5799C19.6867 21.3545 19.9326 20.7808 19.7072 20.2685Z",
    fill: "#B08C3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerProfileIcon);
export default __webpack_public_path__ + "static/media/follower-profile-icon.b44806024940f1cf1cc5dc6b3058e46d.svg";
export { ForwardRef as ReactComponent };